module.exports = __webpack_public_path__ + "img/left.b1486274.svg";